import './errors';

function isApiError(value) {
  if (typeof value !== "object" || value === null || !("error" in value)) return false;
  const { error } = value;
  if (typeof error !== "object" || error === null) return false;
  const { code, message, requestId } = error;
  return typeof code === "string" && typeof message === "string" && typeof requestId === "string";
}

export { isApiError };
//# sourceMappingURL=is-api-error.js.map
//# sourceMappingURL=is-api-error.js.map